<template>
  <div class="isvideo">
    <div class="title">
      <span>{{ title }}</span>
      <button @click="$emit('gocourse', catId)">返回课程主页</button>
    </div>
    <div class="content">
      <div v-if="PlayAuth" class="prism-player" id="myPlayer"></div>
      <div class="notbox" v-else>
        <img src="../../assets/blank/notlist.png" alt="" />
        <p class="inp">视频还在审核中</p>
      </div>
    </div>
  </div>
</template>

<script>
import "../../../lib/aliyun-upload-sdk-1.5.0.min.js";
import "../../../lib/aliyun-oss-sdk-5.3.1.min.js";
import {
  getupdateStatusApi,
  getisvideoApi,
  getSeekTimeApi,
} from "@/request/api";
export default {
  name: "isvideo",
  props: {
    resourceUrl: String,
    title: String,
    catId: [String, Number],
    menuId: [String, Number],
    joined: Boolean,
    chapterId: [String, Number],
    studyTime:  [String, Number],
    isFinished: Boolean,
    isFree:[String,Number]
  },
   sockets:{
     //查看socket是否渲染成功
    connect() {
      console.log("链接成功");
      if (this.isLogin == 0) {
        // console.log(this.isLogin)
        this.$socket.emit("login", { role: this.role, userId:localStorage.getItem('userId')});
          this.$socket.emit("studyStart", { courseId: this.catId,
          taskId: this.menuId});
      }
    },
    studyStart(){
      console.log("进入任务")
    },
     login(){
      console.log("登录")
    }
  },
  data() {
    return {
      isPlay: false,
      PlayAuth: "",
      videoUrl: "",
      videoId: "",
      coverUrl: "",
      player: "",
      seeked: false,
      timer: null,
      currentTime: "",
      Duration: "",
      videoTime: 0,
      updateTimeFlag: false,
      lastTaskId: "",
    };
  },
 computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
    role(){
      return this.$store.state.role
    },
    userId(){
      return this.$store.state.userId
    }
  },
  //常用于时间监听
  watch: {
    resourceUrl: function () {
      this.init();
    },
    PlayAuth: function () {
      this.init();
    },
     isLogin: function (val) {
      //  console.log(val)
    },
     role:function(){

    },
    userId:function(){
      
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      //获取凭证
      this.getToken(getisvideoApi, { videoId: this.resourceUrl }, (res) => {
        //通过接口拿到凭证
        this.PlayAuth = res.data.PlayAuth;
        this.Duration = res.data.VideoMeta.Duration;

        //拿到封面
        this.coverUrl = res.data.VideoMeta.CoverURL;
        var that = this;
        

        //判断是否为试用
        //  console.log("是否为试用：",this.isFree)
        if(this.isFree==1){
              // console.log("")
        }else{
          this.$socket.emit("studyStart",{courseId: this.catId, taskId: this.menuId})
        }
        //先判断是否有播放器容器，存在的话就要注销
        if (this.player) {
          if (!this.updateTimeFlag) {
            // console.log("studyTime:",this.currentTime);
            this.getToken(
              getSeekTimeApi,
              {
                taskId: this.lastTaskId,
                courseId: this.catId,
                studyTime: this.currentTime,
              },
              (res) => {
                this.updateTimeFlag = true;
                // console.log(res);
              }
            );
          }
          this.player.dispose();
          this.seeked = false;
          // this.player.replayByVidAndPlayAuth(this.resourceUrl, this.PlayAuth)
        }
        this.videoTime = this.studyTime;
        this.lastTaskId = this.menuId;

        this.player = new Aliplayer(
          {
            id: "myPlayer", //播放器外层容器的dom元素id
            vid: this.resourceUrl, //视频id
            playauth: this.PlayAuth, // 播放凭证
            width: "100%", //样式
            height: "700px", //样式
            autoplay: false, // 自动播放
            isLive: false, // 直播
            cover: this.coverUrl, //播放器默认封面图片,需要autoplay为’false’时，才生效
            rePlay: false, // 循环播放
            playsinline: true, //H5是否内置播放
            preload: false, //播放器自动加载
            language: "zh-cn",
            controlBarVisibility: "always", //控制面板的实现 ‘click’ 点击出现、‘hover’ 浮动出现、‘always’ 一直在
            useH5Prism: true, //指定使用H5播放器
            encryptType: 1,
          },
          function () {
            // console.log("playAuth:",that.playAuth);
            //  player.replayByVidAndPlayAuth(that.resourceUrl,that.PlayAuth)
            console.log("创建成功了");
          }
        );

        //设置续播事件
        this.player.on("canplaythrough", function (e) {
          if (!that.seeked && that.videoTime != that.Duration) {
            that.seeked = true;
            // console.log("续播！:",that.videoTime);
            that.player.seek(that.videoTime);
          }
        });

        function getTime() {
          that.currentTime = that.player.getCurrentTime();
          that.timer = setTimeout(getTime, 1000);
        }
        //清除定时器
        function clear() {
          if (that.timer) {
            clearTimeout(that.timer);
            that.timer = null;
          }
          that.getToken(
            getSeekTimeApi,
            {
              taskId: that.menuId,
              courseId: that.catId,
              studyTime: that.seeked ? that.currentTime + "" : that.videoTime,
            },
            (res) => {
              that.updateTimeFlag = true;
            }    
          );
        }

        this.player.on("play", function (e) {
          that.updateTimeFlag = false;
          getTime();
        });
        this.player.on("pause", function (e) {
          that.seeked = true;
          clear();
        });
        this.player.on("error", function (e) {
          clear();
        });
        window.onbeforeunload = function (e) {
          e = e || window.event;

          // 兼容IE8和Firefox 4之前的版本
          if (e) {
            e.returnValue = "关闭提示";
            if (that.timer) {
              clear();
            }
          }
          // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
          return "关闭提示";
        };

        // 监听结束事件
        function endedHandle() {
           that.videoTime = that.Duration;
            that.seeked = false;
          if (that.joined) {
            getupdateStatusApi({
              status: 1,
              courseId: that.catId,
              taskId: that.menuId,
                studyTime:that.videoTime
            }).then(() => {
              that.$store.commit("getIds", {
                chapterId: that.chapterId,
                taskId: that.menuId,
              });
              if(that.timer){
                   clearTimeout(that.timer);
                    that.timer = null;
                }
            });
          }
        }
        this.player.on("ended", endedHandle);
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
.isvideo {
  .title {
    height: 65px;
    border-bottom: 1px solid #eee;
    margin-left: 38px;
    margin-right: 39px;
    display: flex;
    position: relative;

    span {
      color: #333333;
      font-size: 18px;
      padding-top: 30px;
    }

    button {
      border: 0;
      outline: none;
      width: 99px;
      height: 30px;
      background-color: #ffffff;
      border: solid 1px #cecece;
      color: #ef9545;
      font-size: 14px;
      position: absolute;
      right: 17px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .content {
    margin: 0 auto;
    margin-top: 24px;
    margin-left: 33px;
    margin-right: 33px;
    margin-bottom: 50px;
    overflow: hidden;
    min-height: 800px;

    video {
      margin-top: 20px;
      width: 100%;
      // height: 700px;
    }

    .notbox {
      margin: 0 auto;
      margin-bottom: 30px;
      margin-top: 40px;
      text-align: center;

      img {
        display: block;
        margin: 0 auto;
      }

      .inp {
        font-size: 18px;
        color: #666;
        margin: 0 auto;
        text-align: center;
        margin-top: 10px;
      }
    }
  }
}
</style>